/* ============================================================
   PINNACLE — WAITLIST.JS v2
   The waitlist form now uses Shopify's native {% form 'customer' %}
   (see sections/waitlist-inline.liquid) — no JS interception needed.
   This file only handles post-submit scroll-back UX.
   ============================================================ */

'use strict';

document.addEventListener('DOMContentLoaded', function () {
  // After a successful native submit, Shopify redirects with
  // ?customer_posted=true — bring the success state into view.
  var params = new URLSearchParams(window.location.search);
  if (params.get('customer_posted') === 'true') {
    var target = document.getElementById('waitlist-signup');
    if (target) {
      setTimeout(function () {
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, 150);
    }
  }
});
